<p-divider *ngIf="showDivider" align="center">
  <span class="text-sm text-color-secondary">{{ 'auth.or_continue_with' | translate }}</span>
</p-divider>

<div class="sso-buttons" [class.compact]="!showDivider">
  <p-button
    (onClick)="loginWithGoogle()"
    [loading]="googleLoading"
    [disabled]="appleLoading"
    severity="secondary"
    outlined
    styleClass="w-full sso-button google-button"
  >
    <div class="provider">
      <app-sso-icon provider="google" />
      <span>{{ 'auth.sso.google' | translate }}</span>
    </div>
  </p-button>

  <p-button
    (onClick)="loginWithApple()"
    [loading]="appleLoading"
    [disabled]="googleLoading"
    severity="secondary"
    outlined
    styleClass="w-full sso-button apple-button"
  >
    <div class="provider">
      <app-sso-icon provider="apple" />
      <span>{{ 'auth.sso.apple' | translate }}</span>
    </div>
  </p-button>
</div>

